import { useStaticQuery, graphql } from 'gatsby'

export default function useGetAllCountry() {
    const data = useStaticQuery(graphql`
        fragment CountryData on builder_CountryData {
            name 
            countryIso
            currencyIso
            currencySymbol
        }
        query {
            allBuilderModels {
                l1: country (limit: 100, options: { cachebust: true }) {
                    id
                    data {
                        ...CountryData
                    }
                }
                l2: country (offset: 100, limit: 100, options: { cachebust: true }) {
                    id
                    data {
                        ...CountryData
                    }
                }
            }
        }
    `)
    const { l1, l2 } = data?.allBuilderModels
    return [...l1, ...l2]
        .map(({ id, data }) => ({ id, ...data }))
        .sort((a, b) => {
            if(!a.name) return -1
            if(!b.name) return 1

            const x = a.name.toLowerCase()
            const y = b.name.toLowerCase()

            if(x < y) return -1
            if(x > y) return 1
            
            return 0
        })
}